import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {SeoAdsListSemanticPrivateSellerMetaConfigMapper} deps.seoAdsListSemanticPrivateSellerMetaConfigMapper
   * @param {SeoAdsListSemanticSevenSeatsMetaConfigMapper} deps.seoAdsListSemanticSevenSeatsMetaConfigMapper
   * @param {SeoAdsListSemanticAutomaticMetaConfigMapper} deps.seoAdsListSemanticAutomaticMetaConfigMapper
   * @param {SeoAdsListSemanticYearMetaConfigMapper} deps.seoAdsListSemanticYearMetaConfigMapper
   * @param {SeoAdsListSemanticMaxPriceMetaConfigMapper} deps.seoAdsListSemanticMaxPriceMetaConfigMapper
   * @param {SeoAdsListSemanticElectricMetaConfigMapper} deps.seoAdsListSemanticElectricMetaConfigMapper
   * @param {SeoAdsListSemanticCampervanMetaConfigMapper} deps.seoAdsListSemanticCampervanMetaConfigMapper
   * @param {SeoAdsListSemanticCaravanMetaConfigMapper} deps.seoAdsListSemanticCaravanMetaConfigMapper
   * @param {SeoAdsListSemanticCarTrailerMetaConfigMapper} deps.seoAdsListSemanticCarTrailerMetaConfigMapper
   * @param {SeoAdsListSemanticCheapVansMetaConfigMapper} deps.seoAdsListSemanticCheapVansMetaConfigMapper
   * @param {SeoAdsListSemanticFinancedMetaConfigMapper} deps.seoAdsListSemanticFinancedMetaConfigMapper
   * @param {SeoAdsListSemanticColorMetaConfigMapper} deps.seoAdsListSemanticColorMetaConfigMapper
   * @param {SeoAdsListSemanticCarsWithoutLicenseMetaConfigMapper} deps.seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper
   * @param {SeoAdsListSemanticEnvironmentalLabelMetaConfigMapper} deps.seoAdsListSemanticEnvironmentalLabelMetaConfigMapper
   * @param {SeoAdsListSemanticLifestyleMetaConfigMapper} deps.seoAdsListSemanticLifestyleMetaConfigMapper
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({
    config,
    seoAdsListSemanticPrivateSellerMetaConfigMapper,
    seoAdsListSemanticSevenSeatsMetaConfigMapper,
    seoAdsListSemanticAutomaticMetaConfigMapper,
    seoAdsListSemanticYearMetaConfigMapper,
    seoAdsListSemanticMaxPriceMetaConfigMapper,
    seoAdsListSemanticElectricMetaConfigMapper,
    seoAdsListSemanticCampervanMetaConfigMapper,
    seoAdsListSemanticCaravanMetaConfigMapper,
    seoAdsListSemanticCarTrailerMetaConfigMapper,
    seoAdsListSemanticCheapVansMetaConfigMapper,
    seoAdsListSemanticClassicCompetitionConfigMapper,
    seoAdsListSemanticTractorsMetaConfigMapper,
    seoAdsListSemanticTrucksConfigMapper,
    seoAdsListSemanticBusesConfigMapper,
    seoAdsListSemanticFinancedMetaConfigMapper,
    seoAdsListSemanticColorMetaConfigMapper,
    seoAdsListSemanticVansMetaConfigMapper,
    seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper,
    seoAdsListSemanticEnvironmentalLabelMetaConfigMapper,
    seoAdsListSemanticLifestyleMetaConfigMapper
  }) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
    this._pageConfig = this._config.get('page')
    this._seoAdsListSemanticPrivateSellerMetaConfigMapper = seoAdsListSemanticPrivateSellerMetaConfigMapper
    this._seoAdsListSemanticSevenSeatsMetaConfigMapper = seoAdsListSemanticSevenSeatsMetaConfigMapper
    this._seoAdsListSemanticAutomaticMetaConfigMapper = seoAdsListSemanticAutomaticMetaConfigMapper
    this._seoAdsListSemanticYearMetaConfigMapper = seoAdsListSemanticYearMetaConfigMapper
    this._seoAdsListSemanticMaxPriceMetaConfigMapper = seoAdsListSemanticMaxPriceMetaConfigMapper
    this._seoAdsListSemanticElectricMetaConfigMapper = seoAdsListSemanticElectricMetaConfigMapper
    this._seoAdsListSemanticCampervanMetaConfigMapper = seoAdsListSemanticCampervanMetaConfigMapper
    this._seoAdsListSemanticCaravanMetaConfigMapper = seoAdsListSemanticCaravanMetaConfigMapper
    this._seoAdsListSemanticCarTrailerMetaConfigMapper = seoAdsListSemanticCarTrailerMetaConfigMapper
    this._seoAdsListSemanticCheapVansMetaConfigMapper = seoAdsListSemanticCheapVansMetaConfigMapper
    this._seoAdsListSemanticClassicCompetitionConfigMapper = seoAdsListSemanticClassicCompetitionConfigMapper
    this._seoAdsListSemanticTractorsMetaConfigMapper = seoAdsListSemanticTractorsMetaConfigMapper
    this._seoAdsListSemanticTrucksConfigMapper = seoAdsListSemanticTrucksConfigMapper
    this._seoAdsListSemanticBusesConfigMapper = seoAdsListSemanticBusesConfigMapper
    this._seoAdsListSemanticFinancedMetaConfigMapper = seoAdsListSemanticFinancedMetaConfigMapper
    this._seoAdsListSemanticColorMetaConfigMapper = seoAdsListSemanticColorMetaConfigMapper
    this._seoAdsListSemanticVansMetaConfigMapper = seoAdsListSemanticVansMetaConfigMapper
    this._seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper = seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper
    this._seoAdsListSemanticEnvironmentalLabelMetaConfigMapper = seoAdsListSemanticEnvironmentalLabelMetaConfigMapper
    this._seoAdsListSemanticLifestyleMetaConfigMapper = seoAdsListSemanticLifestyleMetaConfigMapper
  }

  _getAdsListSemanticConfig = ({path}) => {
    const {adsListSemanticMapper} = this._seoConfig
    const {ADS_LIST_SEMANTIC_REGEXS} = this._pageConfig
    if (!adsListSemanticMapper) return

    const [adsListSemanticPath, adsListSemanticConfig] =
      Object.entries(adsListSemanticMapper).find(semanticEntry => {
        const [semanticPage] = semanticEntry
        const semanticRegex = ADS_LIST_SEMANTIC_REGEXS[semanticPage]
        if (!semanticRegex) return
        return path.match(semanticRegex)
      }) || []

    return {adsListSemanticPath, adsListSemanticConfig}
  }

  map = ({
    path,
    make,
    model,
    bodyType,
    province,
    fuelType,
    year,
    maxPrice,
    version,
    entry,
    sellerTypeId,
    environmentalLabelValue
  }) => {
    const {adsListSemanticPath, adsListSemanticConfig} =
      this._getAdsListSemanticConfig({
        path
      }) || {}

    const isSemantic = Boolean(adsListSemanticConfig)
    if (!isSemantic) return

    const {
      ADS_LIST_SEMANTIC_PRIVATE_SELLER,
      ADS_LIST_SEMANTIC_SEVEN_SEATS,
      ADS_LIST_SEMANTIC_AUTOMATIC,
      ADS_LIST_SEMANTIC_YEAR,
      ADS_LIST_SEMANTIC_MAX_PRICE,
      ADS_LIST_SEMANTIC_ELECTRIC,
      ADS_LIST_SEMANTIC_CAMPERVAN,
      ADS_LIST_SEMANTIC_CAR_TRAILER,
      ADS_LIST_SEMANTIC_CHEAP_VANS,
      ADS_LIST_SEMANTIC_CLASSIC_COMPETITION,
      ADS_LIST_SEMANTIC_TRACTORS,
      ADS_LIST_SEMANTIC_TRUCKS,
      ADS_LIST_SEMANTIC_BUSES,
      ADS_LIST_SEMANTIC_FINANCED,
      ADS_LIST_SEMANTIC_COLOR,
      ADS_LIST_SEMANTIC_VANS,
      ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE,
      ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL,
      ADS_LIST_SEMANTIC_LIFESTYLE
    } = this._pageConfig

    switch (adsListSemanticPath) {
      case ADS_LIST_SEMANTIC_VANS:
        return this._seoAdsListSemanticVansMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, model, province, sellerTypeId, version}
        })

      case ADS_LIST_SEMANTIC_PRIVATE_SELLER:
        return this._seoAdsListSemanticPrivateSellerMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, model, bodyType, province}
        })

      case ADS_LIST_SEMANTIC_SEVEN_SEATS:
        return this._seoAdsListSemanticSevenSeatsMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, model, bodyType, province, fuelType}
        })

      case ADS_LIST_SEMANTIC_AUTOMATIC:
        return this._seoAdsListSemanticAutomaticMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, model, bodyType, province, fuelType}
        })

      case ADS_LIST_SEMANTIC_YEAR:
        return this._seoAdsListSemanticYearMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, year}
        })

      case ADS_LIST_SEMANTIC_MAX_PRICE:
        return this._seoAdsListSemanticMaxPriceMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {maxPrice, province, bodyType, fuelType}
        })

      case ADS_LIST_SEMANTIC_ELECTRIC:
        return this._seoAdsListSemanticElectricMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {province}
        })

      case ADS_LIST_SEMANTIC_CAMPERVAN:
        return this._seoAdsListSemanticCampervanMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {version}
        })

      case ADS_LIST_SEMANTIC_CHEAP_VANS:
        return this._seoAdsListSemanticCheapVansMetaConfigMapper.map({
          adsListSemanticConfig
        })

      case ADS_LIST_SEMANTIC_CAR_TRAILER:
        return this._seoAdsListSemanticCarTrailerMetaConfigMapper.map({
          adsListSemanticConfig
        })

      case ADS_LIST_SEMANTIC_CLASSIC_COMPETITION:
        return this._seoAdsListSemanticClassicCompetitionConfigMapper.map({
          adsListSemanticConfig
        })

      case ADS_LIST_SEMANTIC_TRACTORS:
        return this._seoAdsListSemanticTractorsMetaConfigMapper.map({
          adsListSemanticConfig
        })

      case ADS_LIST_SEMANTIC_TRUCKS:
        return this._seoAdsListSemanticTrucksConfigMapper.map({
          adsListSemanticConfig
        })

      case ADS_LIST_SEMANTIC_BUSES:
        return this._seoAdsListSemanticBusesConfigMapper.map({
          adsListSemanticConfig
        })

      case ADS_LIST_SEMANTIC_FINANCED:
        return this._seoAdsListSemanticFinancedMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {entry}
        })

      case ADS_LIST_SEMANTIC_COLOR:
        return this._seoAdsListSemanticColorMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, model}
        })

      case ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE:
        return this._seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {make, version}
        })

      case ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL:
        return this._seoAdsListSemanticEnvironmentalLabelMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {environmentalLabelValue}
        })

      case ADS_LIST_SEMANTIC_LIFESTYLE:
        return this._seoAdsListSemanticLifestyleMetaConfigMapper.map({
          adsListSemanticConfig,
          params: {path}
        })

      default:
        break
    }
  }
}
